import {Box, Stack, SxProps, Theme, Typography} from '@mui/material';
import {TankLevel} from 'api/api';
import {localized, localizedDynamic} from 'i18n/i18n';
import {FC, memo} from 'react';
import {TankStatusLevel} from 'view/components/default-components/tank-status-level/tank-status-level';
import {TankStatusTemperature} from 'view/components/default-components/tank-status-temperature/tank-status-temperature';

const svgStyles: SxProps<Theme> = {fontSize: '6rem', width: 'auto', height: '1em'};

type TankLevelDescriptionMapper = Record<number, string>;

const tankLevelDescriptionMapper: TankLevelDescriptionMapper = {
  [TankLevel.BelowOk]: localizedDynamic('TankLevel.BelowOK'),
  [TankLevel.LevelOk]: localizedDynamic('TankLevel.LevelOk'),
  [TankLevel.MaximumLevel]: localizedDynamic('TankLevel.Maximum'),
  [TankLevel.MinimumLevel]: localizedDynamic('TankLevel.Minimum'),
};

interface Props {
  tankNumber: number;
  tankLevel?: number;
  tankTemp?: number;
  tankTempStatus?: number;
}

export const TankStatus: FC<Props> = memo((props) => {
  const {tankLevel, tankTemp, tankNumber, tankTempStatus} = props;

  if ((!tankLevel && tankLevel !== 0) || (!tankTempStatus && tankTempStatus !== 0) || (!tankTemp && tankTemp !== 0))
    return <></>;

  return (
    <Stack direction="row" columnGap={2} alignItems="flex-end">
      <Typography>{tankTemp} °C</Typography>
      <Box sx={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
        <Typography marginBottom={1} minWidth={70} textAlign={'center'}>
          {localized('Tank') + ' ' + tankNumber}
        </Typography>
        <Stack flexDirection="row" columnGap={1}>
          <TankStatusTemperature tempStatus={tankTempStatus} sx={svgStyles} />
          <TankStatusLevel sx={svgStyles} tankLevel={tankLevel} />
        </Stack>
      </Box>
      <Typography>{tankLevelDescriptionMapper[tankLevel]}</Typography>
    </Stack>
  );
});
